import { useState } from "react";
import { Col, Container, Row, Collapse } from "reactstrap";

const Collapsable = ({ header, open = false, children, icon, color, fluid = false }) => {
    const [isOpen, setIsOpen] = useState(open);

    return (
        <div className="collapsable-card">
            <hr className="my-0" />
            <Container style={{ padding: 0 }} fluid={fluid}>
                <div className="collapsable-card-control mx-0" onClick={() => setIsOpen(!isOpen)} role="button">
                    <div className="py-3 align-items-center" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 12px' }}>
                        <div className="align-items-center" style={{ display: 'flex' }}>
                            {icon && color && (
                                <div
                                    className={`colored-square-grip-2 me-3 ${color}`}
                                    style={{ display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}
                                >
                                    <i className={`bi ${icon}`}></i>
                                </div>
                            )}
                            <h6 className="mb-0">{header}</h6>
                        </div>
                        <i className="bi bi-chevron-up mx-3" style={{ transform: isOpen ? 'rotate(180deg)' : '', transition: 'transform 250ms ease', transformOrigin: 'center center' }}></i>
                    </div>
                </div>
                <Collapse isOpen={isOpen} className="mt-2" style={{ padding: '0 12px' }}>
                    {children}
                    <br />
                </Collapse>
            </Container>
        </div>
    );
};

export default Collapsable;
